module.exports = __webpack_public_path__ + "static/media/logo-transmute.e81c37a9.svg";